import * as AccountMemberPendingInvitation from 'components/filter/filters-next/filters/AccountMemberPendingInvitation';
import * as AccountMemberRole from 'components/filter/filters-next/filters/AccountMemberRole';
import * as Acknowledged from 'components/filter/filters-next/filters/Acknowledged';
import * as Address from 'components/filter/filters-next/filters/Address';
import * as Archived from 'components/filter/filters-next/filters/Archived';
import * as AssignedTo from 'components/filter/filters-next/filters/AssignedTo';
import * as BidderStatus from 'components/filter/filters-next/filters/BidderStatus';
import * as BouncedEmail from 'components/filter/filters-next/filters/BouncedEmail';
import * as BouncedPhoneNumber from 'components/filter/filters-next/filters/BouncedPhoneNumber';
import * as Campaign from 'components/filter/filters-next/filters/Campaign';
import * as CampaignType from 'components/filter/filters-next/filters/CampaignType';
import * as ChangeOfAddress from 'components/filter/filters-next/filters/ChangeOfAddress';
import * as CheckDeposited from 'components/filter/filters-next/filters/CheckDeposited';
import * as Company from 'components/filter/filters-next/filters/Company';
import * as Contact from 'components/filter/filters-next/filters/Contact';
import * as ContactActivity from 'components/filter/filters-next/filters/ContactActivity';
import * as ContactType from 'components/filter/filters-next/filters/ContactType';
import * as CreationType from 'components/filter/filters-next/filters/CreationType';
import * as CrmMember from 'components/filter/filters-next/filters/CrmMember';
import * as CustomField from 'components/filter/filters-next/filters/CustomField';
import * as DSRating from 'components/filter/filters-next/filters/DSRating';
import * as Date from 'components/filter/filters-next/filters/Date';
import * as Deletable from 'components/filter/filters-next/filters/Deletable';
import * as DueAt from 'components/filter/filters-next/filters/DueAt';
import * as Event from 'components/filter/filters-next/filters/Event';
import * as ExternalLabel from 'components/filter/filters-next/filters/ExternalLabel';
import * as Frequency from 'components/filter/filters-next/filters/Frequency';
import * as Fund from 'components/filter/filters-next/filters/Fund';
import * as HasResource from 'components/filter/filters-next/filters/HasResource';
import * as IncorrectAddress from 'components/filter/filters-next/filters/IncorrectAddress';
import * as InvalidEmail from 'components/filter/filters-next/filters/InvalidEmail';
import * as InvalidPhoneNumber from 'components/filter/filters-next/filters/InvalidPhoneNumber';
import * as LandlinePhoneNumber from 'components/filter/filters-next/filters/LandlinePhoneNumber';
import * as Match from 'components/filter/filters-next/filters/Match';
import * as Message from 'components/filter/filters-next/filters/Message';
import * as PaymentMethod from 'components/filter/filters-next/filters/PaymentMethod';
import * as PaymentStatus from 'components/filter/filters-next/filters/PaymentStatus';
import * as PledgeType from 'components/filter/filters-next/filters/PledgeType';
import * as PotentialIssueAddress from 'components/filter/filters-next/filters/PotentialIssueAddress';
import * as PrimaryAddress from 'components/filter/filters-next/filters/PrimaryAddress';
import * as PromoCode from 'components/filter/filters-next/filters/PromoCode';
import * as QrCode from 'components/filter/filters-next/filters/QrCode';
import * as QuickBooksTransactionStatus from 'components/filter/filters-next/filters/QuickBooksTransactionStatus';
import * as ReportCategory from 'components/filter/filters-next/filters/ReportCategory';
import * as Starred from 'components/filter/filters-next/filters/Starred';
import * as Tag from 'components/filter/filters-next/filters/Tag';
import * as Team from 'components/filter/filters-next/filters/Team';
import * as TeamMember from 'components/filter/filters-next/filters/TeamMember';
import * as Text from 'components/filter/filters-next/filters/Text';
import * as TicketBundle from 'components/filter/filters-next/filters/TicketBundle';
import * as TicketType from 'components/filter/filters-next/filters/TicketType';
import * as TransactionType from 'components/filter/filters-next/filters/TransactionType';
import * as Widget from 'components/filter/filters-next/filters/Widget';

const filterModuleMap = {
    AccountMemberPendingInvitation,
    AccountMemberRole,
    Acknowledged,
    Address,
    Archived,
    AssignedTo,
    BidderStatus,
    BouncedEmail,
    BouncedPhoneNumber,
    Campaign,
    CampaignType,
    TransactionType,
    ChangeOfAddress,
    CheckDeposited,
    Contact,
    ContactType,
    Company,
    ContactActivity,
    CreationType,
    CrmMember,
    CustomField,
    Date,
    Deletable,
    DSRating,
    DueAt,
    Event,
    ExternalLabel,
    Frequency,
    Fund,
    HasResource,
    IncorrectAddress,
    InvalidEmail,
    InvalidPhoneNumber,
    LandlinePhoneNumber,
    Match,
    Message,
    PaymentMethod,
    PaymentStatus,
    PledgeType,
    PotentialIssueAddress,
    PrimaryAddress,
    PromoCode,
    QrCode,
    ReportCategory,
    Starred,
    Tag,
    Team,
    TeamMember,
    Text,
    TicketBundle,
    TicketType,
    Widget,
    QuickBooksTransactionStatus,
};

export { filterModuleMap };
